<template>
  <div class="campus-calendar-container">
    <div class="calendar-date-content" v-clickoutside="clickMonthOutside">
      <div class="date-content" @click.stop="clickMonthPicker">
        {{ currentMonth }}
        <img
          class="arrow-down"
          src="https://logo.wondercv.com/banners/aOO6ri3abBYeQ84.png"
          alt=""
        />
        <div v-show="pickerMonthVisible" class="month-picker-container">
          <div class="year-picker-content">
            <img
              class="arrow-icon"
              src="https://logo.wondercv.com/banners/3PrVqB5oPo0XIxT.png"
              alt=""
              @click.stop="changeYear('prev')"
            />
            <span>{{ pickerYear }}</span>
            <img
              class="arrow-icon"
              src="https://logo.wondercv.com/banners/GwfCrKFGiAu8cEw.png"
              alt=""
              @click.stop="changeYear('next')"
            />
          </div>
          <div class="month-list-content">
            <div
              v-for="(item, index) in monthListData"
              :key="index"
              class="month-item"
              :class="{ active: item.value === pickerMonth }"
              @click.stop="clickMonthItem(item)"
            >
              {{ item.label }}
            </div>
          </div>
        </div>
      </div>
      <div class="today-btn" @click="clickTodayBtn">今天</div>
    </div>
    <div class="week-list-content">
      <div v-for="(item, index) in weekDays" :key="index" class="week-item">
        {{ item }}
      </div>
    </div>
    <div class="calendar-list-content">
      <div
        v-for="(item, index) in fullMonthDates"
        :key="index"
        class="calendar-item"
        :class="[
          { 'today-date': item.date === todayStr },
          { disabled: item.disabled },
          `week-item-${item.weekDay}`,
        ]"
      >
        <div class="calendar-item-date flex align-items-center">
          <span class="day-number">{{ item.day }}</span>
          <span class="day-lunar">{{ item.lunarDayName }}</span>
        </div>
        <template v-if="!!returnSteps(item.date).length">
          <div class="steps-list-content">
            <div v-for="(step, index) in returnSteps(item.date)" :key="index">
              <StepLineItem
                v-if="index < 3"
                :stepItemData="step"
                @clickStepLine="clickStepLine($event, item)"
              />
            </div>
            <div
              v-if="returnSteps(item.date).length > 3"
              class="more-btn"
              @click="clickMoreStepBtn(item)"
            >
              还有
              <span class="number">{{
                returnSteps(item.date).length - 3
              }}</span>
              项
            </div>
          </div>
          <div v-show="item.moreStepVisible" class="more-step-content">
            <div class="more-step-title">
              <span>{{ weekTexts[item.weekDay] }}</span>
              <img
                class="close-icon"
                src="https://logo.wondercv.com/banners/b9WBJGg1ytvcQMU.png"
                alt=""
                @click="item.moreStepVisible = false"
              />
            </div>
            <div class="date-str">
              {{ moment(item.date).format("YYYY年MM月DD日") }}
            </div>
            <div class="more-step-list">
              <StepLineItem
                v-for="(step, index) in returnSteps(item.date)"
                :key="index"
                :stepItemData="step"
                @clickStepLine="clickStepLine($event, item)"
              ></StepLineItem>
            </div>
          </div>
          <div
            v-show="item.recruitDetailVisible"
            class="recruite-detail-container"
          >
            <div class="recruite-detail-title">
              <span>职位详情</span>
              <div class="right-content flex align-items-center">
                <img
                  class="edit-icon"
                  src="https://logo.wondercv.com/banners/4MRDc3GBYEI2WdB.png"
                  alt=""
                  @click="clickEditStep(item)"
                />
                <img
                  class="close-icon"
                  src="https://logo.wondercv.com/banners/b9WBJGg1ytvcQMU.png"
                  alt=""
                  @click="item.recruitDetailVisible = false"
                />
              </div>
            </div>
            <div class="detail-item">
              <span class="detail-item-label">招聘公告</span>
              <span class="detail-item-value">{{
                recruiteDetailData.title
              }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-item-label">企业全称</span>
              <span class="detail-item-value">{{
                recruiteDetailData.company_name
              }}</span>
            </div>
            <div class="detail-item">
              <span class="detail-item-label">岗位</span>
              <span class="detail-item-value post-value">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="recruiteDetailData.post"
                  placement="top-start"
                >
                  <div>{{ recruiteDetailData.post }}</div>
                </el-tooltip>
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-item-label">城市</span>
              <span class="detail-item-value">
                {{ recruiteDetailData.city }}
              </span>
            </div>
            <div
              class="detail-item"
              style="cursor: pointer"
              @click="clickReliver(recruiteDetailData)"
            >
              <span class="detail-item-label">投递方式</span>
              <span class="detail-item-value">
                {{ recruiteDetailData.deliver_email ? "邮箱" : "官网" }}
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-item-label">求职进度</span>
              <span
                class="detail-item-step"
                :style="{
                  background:
                    returnApplicationItem(recruiteDetailData).background,
                  color: returnApplicationItem(recruiteDetailData).color,
                }"
              >
                {{ recruiteDetailData.step }}
              </span>
            </div>
            <div class="detail-item">
              <span class="detail-item-label">备注</span>
              <span class="detail-item-value remark-value">
                {{ recruiteDetailData.remark }}
              </span>
            </div>
          </div>
        </template>
      </div>
    </div>
    <AddCalendarModal
      v-if="editVisible"
      :operationTableItem="recruiteDetailData"
      title="修改信息"
      @close="closeEditModal"
    />
  </div>
</template>
<script>
import api from "@/api";
import { getFullMonthDates, getYearMonths } from "./utils.js";
import { copyToClipboard } from "@/assets/js/util.js";
import { APPLICATION_STATUSES } from "./const.js";
import AddCalendarModal from "./AddCalendarModal.vue";
import StepLineItem from "./StepLine.vue";
import clickoutside from "@/assets/js/clickoutside";
const moment = require("moment");

const WEEK_DAYS = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];
const WEEK_TEXTS = [
  "星期日",
  "星期一",
  "星期二",
  "星期三",
  "星期四",
  "星期五",
  "星期六",
];

export default {
  name: "BlockCampusCalendar",
  components: {
    StepLineItem,
    AddCalendarModal,
  },
  props: {
    activeIndex: Number,
    isLogin: Boolean,
  },
  data() {
    return {
      moment,
      fullMonthDates: [],
      currentMonthStr: moment().format("YYYY-MM"),
      weekDays: WEEK_DAYS,
      weekTexts: WEEK_TEXTS,
      todayStr: moment().format("YYYY-MM-DD"),
      recruiteSteps: [],
      applicationStatuses: APPLICATION_STATUSES,
      recruiteDetailData: {},
      editVisible: false,
      monthPickerVisible: false,
      pickerYear: moment().year(),
      pickerMonth: moment().format("MM"),
      pickerMonthVisible: false,
      monthListData: [],
    };
  },
  directives: {
    clickoutside,
  },
  watch: {
    activeIndex(newVal) {
      if (newVal === 1) this.getRecruiteSteps();
    },
  },
  computed: {
    currentMonth() {
      return moment(this.currentMonthStr).format("YYYY年MM月");
    },
  },
  methods: {
    changeYear(type) {
      switch (type) {
        case "prev":
          this.pickerYear = moment()
            .set("year", this.pickerYear)
            .subtract(1, "year")
            .year();
          break;
        case "next":
          this.pickerYear = moment()
            .set("year", this.pickerYear)
            .add(1, "year")
            .year();
          break;
      }
      this.getMonthListData();
    },
    async clickReliver(data) {
      const { deliver_email, deliver_url } = data;
      if (deliver_email) {
        await copyToClipboard(deliver_email);
        this.$message.success("HR 邮箱已复制，请尽快投递");
      } else if (deliver_url) {
        window.open(deliver_url, "_blank");
      }
    },
    clickMonthOutside() {
      this.pickerMonthVisible = false;
    },
    clickMonthPicker() {
      this.pickerMonthVisible = !this.pickerMonthVisible;
    },
    clickMonthItem(item) {
      this.pickerMonth = item.value;
      const currentMonthStr = `${this.pickerYear}-${this.pickerMonth}`;
      this.fullMonthDates = getFullMonthDates(currentMonthStr);
      this.getRecruiteSteps();
      this.pickerMonthVisible = false;
      this.currentMonthStr = currentMonthStr;
    },
    clickTodayBtn() {
      this.pickerYear = moment().year();
      this.clickMonthItem({
        value: moment().format("MM"),
      });
    },
    returnSteps(dateStr) {
      return this.recruiteSteps.filter(
        (item) => moment(item.step_date).format("YYYY-MM-DD") === dateStr
      );
    },
    returnApplicationItem(step) {
      const applicationItem = this.applicationStatuses.find(
        (item) => item.value === step.step
      );
      if (!applicationItem) return {};
      return applicationItem;
    },
    clickStepLine(step, item) {
      this.fullMonthDates.forEach(
        (item) => (item.recruitDetailVisible = false)
      );
      this.recruiteDetailData = step;
      item.moreStepVisible = false;
      item.recruitDetailVisible = true;
    },
    clickMoreStepBtn(item) {
      this.fullMonthDates.forEach((item) => (item.moreStepVisible = false));
      item.recruitDetailVisible = false;
      item.moreStepVisible = true;
    },
    clickEditStep(item) {
      item.recruitDetailVisible = false;
      this.editVisible = true;
    },
    closeEditModal(type) {
      this.editVisible = false;
      if (type === "refresh") this.getRecruiteSteps();
    },
    getMonthListData() {
      this.monthListData = getYearMonths(this.pickerYear);
    },
    async getRecruiteSteps() {
      if (!this.isLogin) return;
      try {
        const startAt = this.fullMonthDates[0].date;
        const endAt = this.fullMonthDates[this.fullMonthDates.length - 1].date;
        const res = await api.campus.fetchCampusRecuriteSteps({
          start_at: startAt,
          end_at: endAt,
        });
        if (res.code === 1000) {
          this.recruiteSteps = res.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
  },
  mounted() {
    this.fullMonthDates = getFullMonthDates(moment().format("YYYY-MM"));
    this.getMonthListData();
    this.getRecruiteSteps();
  },
};
</script>
<style lang="scss" scoped>
.campus-calendar-container {
  .calendar-date-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
    .date-content {
      position: relative;
      display: flex;
      align-items: center;
      color: #1c212a;
      text-align: center;
      font-size: 20px;
      font-weight: 500;
      cursor: pointer;
      .arrow-down {
        width: 10px;
        object-fit: cover;
        margin-left: 8px;
      }
      .month-picker-container {
        position: absolute;
        top: calc(100% + 16px);
        left: 0;
        width: 280px;
        height: 216px;
        border-radius: 4px;
        border: 1px solid #e5e6eb;
        background: #fff;
        box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
        z-index: 10;
        box-sizing: border-box;
        .year-picker-content {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 0 10px;
          height: 40px;
          color: #1d2129;
          text-align: center;
          font-weight: 500;
          .arrow-icon {
            width: 24px;
            height: 24px;
            cursor: pointer;
          }
        }
        .month-list-content {
          display: flex;
          justify-content: space-between;
          flex-wrap: wrap;
          padding: 0 16px 16px;
          box-sizing: border-box;
          .month-item {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 64px;
            height: 24px;
            color: #1d2129;
            font-weight: 500;
            font-size: 14px;
            margin-top: 16px;
            &.active {
              border-radius: 12px;
              background: #f64;
              color: #fff;
            }
          }
        }
      }
    }
    .today-btn {
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 4px;
      border: 1px solid #e5e6eb;
      color: #1d2129;
      font-size: 14px;
      width: 52px;
      height: 28px;
      cursor: pointer;
    }
  }
  .week-list-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
    .week-item {
      // width: 164px;
      color: #1c212a;
      font-weight: 400;
      flex: 1;
    }
  }
  .calendar-list-content {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    border: 1px solid #e5e6ec;
    border-radius: 8px;
    border-bottom: none;
    border-right: none;
    .calendar-item {
      position: relative;
      width: 165px;
      height: 150px;
      padding: 8px 12px;
      box-sizing: border-box;
      border-bottom: 1px solid #e5e6ec;
      border-right: 1px solid #e5e6ec;
      .calendar-item-date {
        margin-bottom: 12px;
        .day-number {
          color: #1c212a;
          font-size: 16px;
          font-weight: 500;
          margin-right: 8px;
        }
        .day-lunar {
          color: #84909d;
          font-size: 12px;
          font-weight: 500;
        }
      }
      &.today-date {
        padding: 7px 8px;
        .day-number {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 24px;
          height: 24px;
          background-color: #ff6644;
          border-radius: 50%;
          color: #fff;
        }
      }
      &.disabled {
        background-color: #f9fafb;
        .day-number {
          color: #84909d;
        }
      }
      .steps-list-content {
        display: flex;
        flex-direction: column;
        .more-btn {
          display: flex;
          align-items: center;
          position: absolute;
          left: 8px;
          bottom: 11px;
          color: #84909d;
          font-size: 12px;
          font-weight: 400;
          padding-left: 4px;
          height: 25px;
          cursor: pointer;
          width: 150px;
          box-sizing: border-box;
          &:hover {
            border-radius: 4px;
            background: #f2f3f5;
          }
          .number {
            color: #ff6644;
            margin: 0 4px;
          }
        }
      }
      .more-step-content {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 100%;
        padding: 20px;
        border-radius: 8px;
        border: 1px solid #f2f3f5;
        background: #fff;
        box-shadow: 0px 8px 20px 0px rgba(29, 33, 41, 0.12);
        width: 240px;
        height: 225px;
        z-index: 8;
        box-sizing: border-box;
        color: #1c212a;
        .more-step-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 4px;
          font-size: 12px;
        }
        .date-str {
          font-size: 16px;
          font-weight: 500;
          margin-bottom: 12px;
        }
        .more-step-list {
          height: calc(100% - 42px);
          overflow-y: scroll;
          &::-webkit-scrollbar {
            display: none;
          }
          .step-line-container {
            margin-bottom: 0;
            margin-top: 8px;
          }
        }
      }
      .recruite-detail-container {
        @extend .more-step-content;
        width: 260px;
        height: fit-content;
        .recruite-detail-title {
          display: flex;
          justify-content: space-between;
          align-items: center;
          color: #1c212a;
          font-size: 16px;
          font-weight: 500;
          padding-bottom: 16px;
          border-bottom: 1px solid #e5e6ec;
        }
        .detail-item {
          display: flex;
          margin-top: 16px;
          .detail-item-label {
            width: 60px;
            margin-right: 20px;
            flex-shrink: 0;
            color: #84909d;
            font-weight: 500;
            line-height: normal;
          }
          .detail-item-value {
            color: #1c212a;
            line-height: normal;
            white-space: pre-line;
            &.post-value {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 6;
              cursor: pointer;
            }
            &.remark-value {
              display: -webkit-box;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
              -webkit-line-clamp: 10;
              cursor: pointer;
            }
          }
          .detail-item-step {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 50px;
            height: 18px;
            border-radius: 4px;
            font-size: 10px;
            font-weight: 500;
            white-space: nowrap;
            flex-shrink: 0;
          }
        }
      }
      .close-icon,
      .edit-icon {
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
      .edit-icon {
        margin-right: 16px;
      }
      &.week-item-0,
      &.week-item-6,
      &.week-item-5 {
        .more-step-content,
        .recruite-detail-container {
          left: auto;
          right: 100%;
        }
      }
    }
  }
}
</style>
